import GameStepBase, {cancelGameFlow} from './game_step_base';
import RestrictionMessages from '../../restrictions/messages/restriction_messages';


export default class LoginGameStep extends GameStepBase {
    static CLASS = 'LoginGameStep';

    run(gameOptions) {
        if(this.serviceFactory.oAuth2Service().isAuthorized()) {
            return Promise.resolve(gameOptions);
        }

        return this.serviceFactory.webLoginService().openLoginForm().then(() => {
            // after login we need to update the gameInfo inside the gameOptions to get a gameInfo with updated restrictions
            return this.serviceFactory.gamesInformationService().getGamesInfo([gameOptions.gameType])
                .then(gamesInfo => gamesInfo[gameOptions.gameType])
                .then(gameInfo => {
                    if(gameInfo) {
                        return Object.assign(gameOptions, {
                            gameInfo: gameInfo
                        });
                    } else {
                        this._showGenericRestrictionMessage();
                    }
                })

        }).catch(err => {
            if (!err) {
                return cancelGameFlow('USER CANCELED THE LOGIN');
            } else {
                throw err;
            }
        });
    }

    _showGenericRestrictionMessage() {
        return RestrictionMessages.create({
            serviceFactory: this.serviceFactory
        }).showGenericMessage();
    }
}